import MolhamButton from "components/ReuseableCompos/MolhamButton";
import useTranslation from "next-translate/useTranslation";
import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import { useModeContext } from "../../context/ModeContext";
type Props = {
  onClose: () => void;
  goldPriceFromProps: { [key: number]: number };
  silverPriceFromProps: number;
  curr: any;
  returnData: (data: any) => void;
  typesConsts: any;
  isEdit: boolean;
  editCardInfo: any;
};
export default function ZakatCalculatorAssetModal({
  onClose,
  goldPriceFromProps,
  silverPriceFromProps,
  curr,
  returnData,
  typesConsts,
  isEdit,
  editCardInfo,
}: Props) {
  const { t } = useTranslation("common");
  const { theme } = useModeContext();
  const defualtVals = {
    karat: 24,
    amount: 0,
    description: "",
  };
  const fieldTypes = ["money", "gold", "silver", "stock"];
  const [type, setType] = React.useState(isEdit ? editCardInfo.type : "money");
  const [karat, setKarat] = React.useState(
    isEdit ? editCardInfo.karat : defualtVals.karat
  );
  const [prices, setPrices] = React.useState({
    money: 1,
    gold: goldPriceFromProps,
    silver: silverPriceFromProps,
    stock: isEdit ? editCardInfo.price : 1,
  });
  const [amount, setAmount] = React.useState(
    isEdit ? editCardInfo.amount : defualtVals.amount
  );
  const [description, setDescription] = React.useState(
    isEdit ? editCardInfo.description : defualtVals.description
  );
  const resetToDefault = () => {
    setKarat(24);
    setPrices((prev) => {
      return {
        ...prev,
        stock: 0,
      };
    });
    setAmount(0);
    setDescription("");
  };
  const submit = () => {
    if (amount > 0) {
      const data = {
        type,
        amount,
        description,
        price: type == "gold" ? prices[type][karat] : prices[type],
        karat: type == "gold" ? karat : undefined,
        consts: typesConsts[type],
      };
      returnData(removeUndefined(data));
      resetToDefault();
      onClose();
    }
  };
  return (
    <>
      <Form.Group className="pb-3">
        <Form.Label className="px-2">{t("asset_category")}</Form.Label>
        <Form.Control
          className="form-select"
          as="select"
          value={type}
          onChange={(e) => {
            setType(e.target.value);
            resetToDefault();
          }}
        >
          {fieldTypes.map((fieldType) => (
            <option key={fieldType} value={fieldType}>
              {t(`${fieldType}_asset`)}
            </option>
          ))}
        </Form.Control>
      </Form.Group>
      {type == "gold" && (
        <Form.Group className="pb-3">
          <Form.Label className="px-2">{t("gold_karat")}</Form.Label>
          <Form.Control
            as="select"
            className="form-select"
            value={karat}
            onChange={(e) => {
              setKarat(e.target.value);
            }}
          >
            {typesConsts[type].karats.map((fieldType) => (
              <option value={fieldType} key={fieldType}>
                {fieldType}
              </option>
            ))}
          </Form.Control>
        </Form.Group>
      )}

      <Form.Group className="pb-3">
        <Form.Label className="px-2">
          {t(typesConsts[type].amount_label)}
        </Form.Label>
        <InputGroup>
          <InputGroup.Text
            style={theme === "dark" ? { border: "1px solid #2c2d3f" } : null}
          >
            {typesConsts[type].append === "currency"
              ? curr.symbol ?? curr.code.toUpperCase()
              : t(typesConsts[type].append)}
          </InputGroup.Text>

          <Form.Control
            type="number"
            placeholder={t(typesConsts[type].amount_label)}
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value);
            }}
          />
        </InputGroup>
      </Form.Group>

      {type !== "money" && (
        <Form.Group className="pb-3">
          <Form.Label className="px-2">
            {t(typesConsts[type].price_label)}
          </Form.Label>
          <InputGroup>
            <InputGroup.Text
              style={theme === "dark" ? { border: "1px solid #2c2d3f" } : null}
            >
              {curr.symbol ?? curr.code.toUpperCase()}
            </InputGroup.Text>

            <Form.Control
              type="number"
              placeholder={t(typesConsts[type].price_label)}
              value={type == "gold" ? prices[type][karat] : prices[type]}
              onChange={(e) => {
                setPrices((prev) => ({
                  ...prev,
                  [type]:
                    type === "gold"
                      ? { ...prev[type], [karat]: e.target.value }
                      : e.target.value,
                }));
              }}
            />
          </InputGroup>
        </Form.Group>
      )}
      <Form.Group className="pb-3">
        <Form.Label className="px-2">{`${t("description")} (${t(
          "optional"
        )})`}</Form.Label>
        <Form.Control
          type="text"
          placeholder={`${t("optional")}...`}
          value={description}
          onChange={(e) => {
            setDescription(e.target.value);
          }}
        />
      </Form.Group>
      <MolhamButton
        id={`zakat-asset-${isEdit ? "edit" : "add"}-btn`}
        label={isEdit ? t("edit") : t("add")}
        className={`mt-2 w-100`}
        onClick={submit}
        disabled={amount <= 0}
      />
    </>
  );
}

export const removeUndefined = (o) =>
  Object.entries(o)
    .filter(([, val]) => val !== undefined)
    .reduce((result, [key, val]) => {
      result[key] = val;
      return result;
    }, {});
